import {FeatureEditor} from 'mc/lib/mapio';
import {localUTCToDate} from 'mc/lib/utils/commons';

const {SymbolicDate} = FeatureEditor;

export function getFeaturesFromLokalitaList(lokalitaList) {
    return lokalitaList
        .map(getFeaturesFromLokalita)
        .reduce(concatArrays, []);
}

function getFeaturesFromLokalita(lokalita) {
    return lokalita.geodata;
}

export function createFeatureFilterFromLokalitaList(lokalitaList) {
    return createFeatureFilter(getMinDatumPocatekFromLokalitaList(lokalitaList));
}

export function createFeatureFilterFromObdobiList(obdobiList) {
    return createFeatureFilter(getMinDatumPocatekFromObdobiList(obdobiList))
}

function createFeatureFilter(minDatumPocatek) {
    return minDatumPocatek != null
        ? {dateFrom: minDatumPocatek}
        : {date: SymbolicDate.FROM_TODAY};
}

function getMinDatumPocatekFromLokalitaList(lokalitaList) {
    return lokalitaList
        .map(getMinDatumPocatekFromLokalita)
        .reduce(chooseMinDate, null);
}

function getMinDatumPocatekFromLokalita(lokalita) {
    return getMinDatumPocatekFromObdobiList(lokalita.obdobiList);
}

function getMinDatumPocatekFromObdobiList(obdobiList) {
    return obdobiList
        .map(getObdobiDatumPocatek)
        .filter(Boolean)
        .reduce(chooseMinDate, null);
}

function getObdobiDatumPocatek(obdobi) {
    return localUTCToDate(obdobi.datumPocatek);
}

function chooseMinDate(date1, date2) {
    return (date1 == null || date2 < date1) ? date2 : date1;
}

function concatArrays(array1, array2) {
    return array1.concat(array2);
}
